import { parse } from 'qs'
import { seal } from '@/api/encryption'
import { smartPush } from '@/util/navigation'
import router from '@/router'

export const Vue2CompatPlugin = {
  install(app) {
    // 在组件实例中注入 $set 方法
    app.mixin({
      beforeCreate() {
        this.$set = (obj, key, value) => {
          if (Array.isArray(obj) && typeof key === 'number') {
            obj.splice(key, 1, value);
          } else {
            obj[key] = value;
          }
        };
        
        // 可选：添加 $delete 兼容
        this.$delete = (obj, key) => {
          if (Array.isArray(obj)) {
            obj.splice(key, 1);
          } else {
            delete obj[key];
          }
        };

        this.$openNewPage = (path, query) => {
          // 拼接 URL
          let newQuery = query
          if (path.includes('/customInstrument')) {
            if (path.includes('?')) {
              const pathQuery = parse(path.split('?')[1])
              path = path.split('?')[0]
              query = { ...pathQuery, ...query }
            }
            newQuery = seal(query)
          }
          const { href } = this.$router.resolve({
            path: path,
            query: newQuery,
          });
          window.open(href, '_blank');
        }

        this.$openAdmin = (to, opt) => {
          // 确保跳转到中台时带有前缀
          const target = typeof to === 'string' ? to : { ...to };
          const path = typeof to === 'string' ? to : to.path;
          
          if (!path.startsWith('/cust')) {
            window.open(`${window.location.origin}/cust${path}`, '_blank');
          }
          smartPush(target, router, opt);
        }
      }
    });
  }
};